import actions from './actions';
import { onLoadMultiDaySuccess } from '../../../../jobs/common/reducers';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  jobs: [],
  filteredTotal: 0,
  filters: [],
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters } = payload;
  const jobs = data.map(record => (record.multi_day ? { ...record, children: [] } : record));

  return {
    ...state,
    jobs,
    filteredTotal,
    filters,
    loading: false,
    total,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_MULTI_DAY_SUCCESS]: onLoadMultiDaySuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
